<template>
  <div id="sideBar">
    <div class="menuList">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        class="menuSin"
        :class="activeMenu == index ? 'active' : ''"
        @click="changeMenu(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeMenu: -1,
      menuList: [
        {
          name: 'Users',
          link: '/users',
        },
        {
          name: 'Link Tool',
          link: '/linktool',
        },
        {
          name: 'Advertisers',
          link: '/advertisers',
        },
        {
          name: 'Influencers',
          link: '/influencers/pending',
        },
        {
          name: 'Reports',
          link: '/reports',
        },
        {
          name: 'Commissions',
          link: '/commissions',
        },
        {
          name: 'Links Analytics',
          link: '/links-analytics',
        },
        {
          name: 'Payments',
          link: '/payments/dm-received',
        },
        {
          name: 'Settings',
          link: '/settings',
        },
      ],
    }
  },
  mounted() {
    let currrentPath = this.$router.currentRoute._value.path

    for (var key in this.menuList) {
      if (currrentPath == this.menuList[key].link) {
        this.activeMenu = key
      }
    }

    if (
      currrentPath.indexOf('advertiser/') != -1 ||
      currrentPath.indexOf('affiliate/edit') != -1
    ) {
      this.activeMenu = 2
    }

    // Ensure Payments is highlighted for any payments sub-path (like payments/pending-payment)
    if (currrentPath.indexOf('/payments') === 0) {
      this.activeMenu = 7
    }

    if (currrentPath.indexOf('/reports') === 0) {
      this.activeMenu = 4
    }

    if (currrentPath.indexOf('influencer') != -1) {
      this.activeMenu = 3
    }

    window.addEventListener('hashchange', this.hashchange)
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.hashchange)
  },
  methods: {
    changeMenu(item, index) {
      this.$router.push({
        path: item.link,
      })
      this.activeMenu = index
    },
    hashchange() {
      let path = location.hash.substring(1)

      // 编辑联盟页默认选中Advertisers
      if (
        path.indexOf('/affiliate/edit') != -1 ||
        path.indexOf('/advertiser') != -1
      ) {
        path = '/advertisers'
      }

      if (path.indexOf('/payments') != -1) {
        path = '/payments/dm-received'
      }

      if (path.indexOf('/influencer') != -1) {
        path = '/influencers/registered'
      }

      if (this.menuList[this.activeMenu]['link'].indexOf(path) !== 0) {
        for (var key in this.menuList) {
          if (path == this.menuList[key].link) {
            this.activeMenu = key
          }
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
#sideBar {
  width: 100%;
  height: 100%;
  .menuList {
    user-select: none;
    .menuSin {
      height: 40px;
      display: block;
      cursor: pointer;
      padding: 0 10px;
      font-size: 16px;
      line-height: 40px;
      margin-right: 20px;
      text-align: center;
      border-radius: 6px;
      transition: all 0.5s;
      &.active {
        background: #fff;
      }
    }
  }
}
</style>